//@flow
import _ from 'lodash';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import FullCustomCard from '../../components/FullCustomCard/FullCustomCard';
import TopoTitleComponente from '../../components/PageTitle/TopoTitleComponente';
import TopoListagem from '../../components/Topo/TopoListagem';
import { objectsConstants } from '../../_constants/objects.constants';
import { userService } from '../../_services/user.service';
import UsuarioFinanceiroForm from './UsuarioFinanceiroForm';
import { usuarioFinanceiroService } from '../../_services/usuarioFinanceiro.service';

// const defaultArrayItem = [{ idList: new Date().getTime() }];

class UsuarioFinanceiroView extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {
      entity: { status: true },
    };
  }

  componentDidMount() {
    this.loadUser();
  }

  loadUser = () => {
    if (this.props.match.params.id) {
      this.props.loading(true);
      usuarioFinanceiroService.doGet(this.props.match.params.id).then(
        (response) => {
          let usuarioFinanceiro = response.data.data;
          if (!usuarioFinanceiro.hasOwnProperty('status')) {
            usuarioFinanceiro.status = false;
          }

          this.setState({ entity: usuarioFinanceiro }, () => {
            this.props.loading(false);
          });
        },
        (error) => {
          console.log(error);
          this.props.loading(false);
        }
      );
    }
  };
  handleCancel = () => {
    this.props.history.goBack();
  };




  handleChange = (name, value) => {
    const entity = _.cloneDeep(this.refFormComponent.state.values);
    _.set(entity, name, value);
    this.setState({ entity });
  };

  handleSubmit = (e) => {
    this.refFormComponent
      .validateForm(this.refFormComponent.values)
      .then((erros) => {
        console.log(erros);
        if (_.isEmpty(erros)) {
          this.refFormComponent.handleSubmit();
        }
      });
  };

  render() {
    const { entity } = this.state;
    const { ...otherPops } = this.props;
    return (
      <React.Fragment>
        {entity.id && (
          <React.Fragment>
            <TopoTitleComponente
              mainTitle={`${entity.id ? 'Editar ' : 'Novo '}  usuário`}
              canBack={true}
              backUrl={!entity.id ? null : '/usuarioFinanceiro'}
            />
            <TopoListagem
              showIndisponibilidade={false}
              showfilter={false}
            ></TopoListagem>

            <div className="flex-column">
              <FullCustomCard
                permissionSave={objectsConstants.CRUD_USUARIOS_FINANCEIRO}
                ref={(form) => {
                  this.refFormComponent = form;
                }}
                title="Usuário"
                Componente={UsuarioFinanceiroForm}
                viewMode={true}
                entity={entity}
                cancelForm={this.loadUser}
                onSave={this.loadUser}
                // btnExcluir={true}
                {...otherPops}
              ></FullCustomCard>
            </div>
            {<div className="flex-column"></div>}
          </React.Fragment>
        )}
        {/* </div> */}
      </React.Fragment>
    );
  }
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(null, mapDispatch, null)(withRouter(UsuarioFinanceiroView));
